export default defineNuxtRouteMiddleware(async (to) => {
  const { apiURL, appEnv } = useRuntimeConfig().public;

  if (import.meta.client && appEnv != "development") {
    const referer = document.referrer;
    const JsessionCookie = useCookie("JSESSION");
    let retryCounter = 0;

    const fetchStoreRefLog = async () =>
      fetch(
        new URL(
          `${apiURL}/apis/refdata/storeRefLog${to.query
            ? `?${new URLSearchParams(to.query as Record<string, string>)}`
            : ""
          }`
        ),
        {
          headers: new Headers({
            "x-cja-referer": referer ?? "",
          }),
        }
      );

    while (retryCounter < 3) {
      try {
        if (JsessionCookie.value) {
          fetchStoreRefLog();
        } else {
          await fetchStoreRefLog();
        }

        retryCounter = 3;
      } catch {
        retryCounter++;
      }
    }
  }
});
